<script>
import { createEventDispatcher, onMount } from 'svelte';
import { trans } from '@/utils';

const dispatch = createEventDispatcher();

export let principles = [];
export let active = [];
export let counters = {};
export let total;
export let disabledOptions = {};
export let help = '';

const notify = () => {
    dispatch('change', active);
}

</script>

<div class="fl_principles py-lg-4 p-0">
  <div class="container">

    <div class="helpbox help" id="help3">
      {@html help}
    </div>


<div class="d-lg-flex">
  {#each principles as p (p.id)}
    {@const percent = active.includes(p.id) ? Math.round(counters[p.id]/total*100, 2) : 0}
    {@const disabled = disabledOptions.principles && disabledOptions.principles[p.id]}
    <div class="flex-even">
      <div class="p-lg-3 p-0 d-flex d-lg-block align-items-center">

        <div class="order-2 order-lg-1 flex-fill ms-3 ms-lg-0 py-2 py-lg-0">

          <div class="title d-block d-lg-flex align-items-end">
            <label class="form-check-label" for="principle-{p.id}">{p.name}</label>
          </div>

          <div class="my-2" data-tooltip="{`${counters[p.id]} ${trans('n_initiatives')}`}">
            <div class="progress rounded-pill" style="height: 8px;">
              <div class="progress-bar rounded-pill" style="width:{percent}%;background:{p.color || '#fff'}" role="progressbar" aria-valuenow="{percent}" aria-valuemin="0" aria-valuemax="100"></div>
            </div>
          </div>

        </div>

        <div class="order-1 order-lg-2 form-check form-switch">
          <input class="form-check-input" type="checkbox" {disabled} role="switch" id="principle-{p.id}" value={p.id} bind:group={active} on:change={notify}>
        </div>

      </div>
    </div>
  {/each}
</div>
</div>

</div>
